import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderDocumentDeleteDialogComponent } from './work-order-document-delete-dialog.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatIconModule } from '@angular/material/icon';
import { CtButtonModule } from '@ctsolution/ct-framework';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    WorkOrderDocumentDeleteDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatLegacyDialogModule,
    MatLegacyCheckboxModule,
    MatIconModule,
    CtButtonModule,
    TranslateModule
  ],
  exports: [
    WorkOrderDocumentDeleteDialogComponent
  ]
})
export class WorkOrderDocumentDeleteDialogModule { }
